
import { SupabaseClient } from "@supabase/supabase-js";

export interface User {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  gender?: "male" | "female";
  timezone?: string;
  plan: "free" | "pro";
}

export interface AuthContextType {
  user: User | null;
  isAuthenticated: boolean;
  loading: boolean;
  error: string | null;
  login: (email: string, password: string) => Promise<void>;
  signup: (email: string, password: string, firstName: string, lastName: string, gender?: "male" | "female") => Promise<void>;
  logout: () => void;
  resetPassword: (email: string) => Promise<void>;
  upgradeAccount: () => Promise<void>;
  supabase: SupabaseClient;
}

// Demo user for direct login without requiring Supabase authentication
export const DEMO_USER: User = {
  id: "demo-user-id",
  email: "demo@example.com",
  firstName: "Demo",
  lastName: "User",
  gender: "male", // Default gender for demo user
  timezone: undefined, // Will be set dynamically
  plan: "pro"
};
